
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1729478545039",
    "width": "48",
    "height": "48",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "3197",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 298.6496a85.3504 85.3504 0 1 0 0-170.6496 85.3504 85.3504 0 0 0 0 170.6496z",
        "fill": "#058E44",
        "p-id": "3198"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 512m-85.3504 0a85.3504 85.3504 0 1 0 170.7008 0 85.3504 85.3504 0 1 0-170.7008 0Z",
        "fill": "#058E44",
        "p-id": "3199"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 896a85.3504 85.3504 0 1 0 0-170.7008 85.3504 85.3504 0 0 0 0 170.7008z",
        "fill": "#058E44",
        "p-id": "3200"
      }
    }
  ]
})
    }
  